import {Link} from 'react-router-dom'
import {FormattedMessage} from 'react-intl'
import {parseId} from '../../../helpers'
import {EdgeMemberPolicy, NodeMemberPolicy, NodePolicy} from '../../../types/policiesApi'
import {PhoneProviderActions} from '../../../components/telephony/PhoneProviderActions'

interface IInfoClientProps {
  id: string
  members?: EdgeMemberPolicy[]
  holder?: NodeMemberPolicy | null
  policy: NodePolicy
  isQuote?: boolean
}

export const InfoClientPolicy: React.FC<IInfoClientProps> = ({
  id,
  members = [],
  holder,
  policy,
  isQuote,
}) => {
  const holderFromMembers = members.find(({node}) => node.rol === 'HOLDER')?.node
  const holderNode = holder || holderFromMembers

  if (!holderNode) {
    return (
      <div style={{maxWidth: '280px', minWidth: '200px'}}>
        <Link
          to={isQuote ? `/one-quote/${parseId(id)}` : `/one-policy/${parseId(id)}`}
          className='text-info'
        >
          <FormattedMessage id='policies.list.info.noHolder' defaultMessage='No holder yet' />
        </Link>
        <p className='m-0 p-0'></p>
        <p className='m-0 p-0'></p>
      </div>
    )
  }

  const holderFullName = `${holderNode.firstName} ${holderNode.lastName}`

  return (
    <div style={{maxWidth: '280px', minWidth: '200px'}}>
      <Link
        to={isQuote ? `/one-quote/${parseId(id)}` : `/one-policy/${parseId(id)}`}
        className='text-primary text-link fw-bold'
        style={{
          display: 'block',
          wordBreak: 'break-word',
          lineHeight: '1.3',
          whiteSpace: 'normal',
        }}
      >
        {policy.policyName ?? holderFullName}
      </Link>
      <div className='m-0 p-0' style={{fontSize: '0.95rem'}}>
        <PhoneProviderActions phone={holderNode.phone} />
      </div>
      <p className='m-0 p-0' style={{fontSize: '0.95rem'}}>{policy.stateEU?.code} {policy.zipCode ?? ''}</p>
    </div>
  )
}
